'use strict'

import Axios, { AxiosInstance } from "axios";
import { FeedbackForm, FeedbackFormExtended, FeedbackRaffle} from '@/models/feedback-form';

export class FeedbackFormService {
  private _api!: AxiosInstance;

  constructor() {
    this._api = Axios.create({
      baseURL: process.env.VUE_APP_ECE_API_URL,
      responseType: 'json',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-api-key': 'eaQSPYWOqAbDOpjX3zFC2bDJvh6z7wB3wV888d25'
      }
    });
  }

  async get(workflowId: string): Promise<FeedbackForm> {
    const response = await this._api.get<FeedbackForm>(`/FeedbackForm/${workflowId}?nocache=${new Date().getTime()}`)
    return response.data;
  }

  async create(feedbackFormData: FeedbackFormExtended): Promise<FeedbackForm> {
    const response =  await this._api.post<FeedbackForm>('FeedbackForm', feedbackFormData);
    return response.data;
  }

  async update(workflowId: string, feedbackForm: FeedbackForm): Promise<FeedbackForm> {
    const response =  await this._api.put<FeedbackForm>(`/FeedbackForm/${workflowId}`, feedbackForm)
    return response.data;
  }

  async getFeedbackRaffle(token: string): Promise<FeedbackRaffle> {
    const response = await this._api.get<FeedbackRaffle>(`/FeedbackRaffle/${token}`);
    return response.data;
  }
}
